/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-btn[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;margin-bottom:20px}.modal-btn[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{width:80%}[_ngcontent-%COMP%]::marker{color:#dd5f13;font-size:26px}.text-modal[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center;font-size:18px}.disclaimer[_ngcontent-%COMP%]{width:90%;text-align:center}"];
export { styles as styles };
